

  if (import.meta.env.PROD && Object.is(import.meta.env.VITE_BUILD_ENV, "prod")) {
    try {
      //@ts-ignore
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-TQMX7B9X');
      const noscriptHtml =
        "<noscript><iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-TQMX7B9X\"\n" +
        "height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe></noscript>";
      document.body.insertAdjacentHTML("beforeend", noscriptHtml);

      //meta
      !function(f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
          n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      }(window, document, "script",
        "https://connect.facebook.net/en_US/fbevents.js");
      fbq("init", "1227917452065496");
      fbq("track", "PageView");
      const metaNoscriptHtml = `<noscript><img height="1" width="1" style="display:none"
               src="https://www.facebook.com/tr?id=1227917452065496&ev=PageView&noscript=1"
/></noscript>`;
      document.body.insertAdjacentHTML("beforeend", metaNoscriptHtml);
      //插入facebook脚本
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      document.head.appendChild(script);
    } catch (e) {
      console.log(e);
    }
  }

